import React from 'react';
import FeesModal from '../feesModal/FeesModal';
import { FeesAction } from 'lib/type/enums';

function PaymentFeeModal({
    fee,
    handleSubmit,
    closeModal,
    isInternalPayee,
    amount,
}) {
    return (
        <FeesModal
            action={FeesAction.PAYMENT}
            fee={fee}
            handleSubmit={handleSubmit}
            closeModal={closeModal}
            isInternalPayee={isInternalPayee}
            amount={amount}
        />
    );
}

export default PaymentFeeModal;
